import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/components/ui-kit";
import { ClipboardCheck } from "lucide-react";

const ATT = { Present: "bg-emerald-100 text-emerald-700", Late: "bg-amber-100 text-amber-700", Absent: "bg-rose-100 text-rose-700", Leave: "bg-sky-100 text-sky-700" };

export function DayReportCard({ student }) {
  const [rep, setRep] = useState(null);
  useEffect(() => {
    api.get("/day-reports", { params: { student_id: student.id } }).then((r) => setRep(r.data[0] || null)).catch(() => setRep(null));
  }, [student.id]);
  if (!rep) return null;
  return (
    <div data-testid="day-report-card" className="rounded-2xl border border-pink-100 bg-gradient-to-br from-pink-50 to-white p-4 mb-4">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
        <div className="font-display font-bold text-slate-900 flex items-center gap-2"><ClipboardCheck size={17} className="text-pink-600" />Day report · {fmtDate(rep.date)}</div>
        {rep.attendance && <span data-testid="day-report-attendance" className={`text-xs font-semibold px-2.5 py-1 rounded-full ${ATT[rep.attendance] || "bg-slate-100 text-slate-600"}`}>{rep.attendance}</span>}
      </div>
      {rep.items.length ? (
        <div className="grid sm:grid-cols-2 gap-x-4 gap-y-1 text-sm">
          {rep.items.map((i) => <div key={i.label}><span className="font-semibold text-slate-700">{i.label}:</span> <span className="text-slate-600">{i.value}</span></div>)}
        </div>
      ) : <p className="text-sm text-slate-500">No daily activity was logged — attendance only.</p>}
      {rep.teacher_name && <div className="text-xs text-slate-400 mt-2">From {rep.teacher_name}</div>}
    </div>
  );
}
